module["exports"] = [
  "/34##-######-####L/",
  "/37##-######-####L/"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/credit_card/american_express.js
// module id = 1282
// module chunks = 1